/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h } from "preact";
import styled from "styled-components";
import SearchSrc from "@images/1.svg";
import BtnSrc from "@images/2.svg";
import { useEffect, useRef } from "preact/hooks";
let flag=true;
const SearchWrap: any = ({searchInputTextChange,handleSearch,keywords}: any) => {
    const SearchRef: any = useRef();
    const action = () => {
        SearchRef.current.blur();
        handleSearch();
    };
    useEffect(()=>{
        document.addEventListener("compositionstart",(e)=>{
            flag=false;
        })
        document.addEventListener("compositionend",(e)=>{
            flag=true;
            searchInputTextChange(e);
        })
    },[])
    return (<Container>
         <form
            style={{width:"100%"}}
            action="#"
            onSubmit={action}
            onKeyDown={(e) => {
              if (e.keyCode == 13) action();
            }}
          >
        <SearchOut>
            <Icon src={SearchSrc} />
            <input
                value={keywords}
                ref={SearchRef}
                className="search-input"
                placeholder="输入商品名称"
                type="Search"
                onChange={(e)=>{
                    if(flag){
                        searchInputTextChange(e)
                    }
                }}
            />
            <SearchBtn src={BtnSrc} onClick={()=>{action()}} />
        </SearchOut>
        </form>
    </Container>)
}

export default SearchWrap;

const Container = styled.div`
    margin-top:24px;
    width:702px;
    display: flex;
    flex-direction: row;
    align-items: center;
 `;
 const SearchOut=styled.div`
    width: 100%;
    height: 68px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 32px;
    background: #fff;
    padding: 0 8px 0 20px;
 `;
 const Icon=styled.img`
    width: 32px;
    height: 32px;
 `;
 const SearchBtn=styled.img`
    width: 100px;
 `;